const state = {

};

const getters = {

};


const actions = {
    async getItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/user-duty`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getUserItemsByRole({ commit },params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/user-duty/user-list-by-role`,{ params : params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async createItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/user-duty`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/user-duty/${data.id}`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deleteItems({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/user-duty`, {
                    data: {
                        ids: ids
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async exportItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/user-duty/export`, { params: params })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async getUserDutyDetail({ commit },params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/user-duty/combine`,{ params : params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async checkUserDutyServiceCategory({ commit },params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/user-duty/check-service-category`,{ params : params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateMutilItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/user-duty/mutil`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deleteMutilItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/user-duty/mutil`, {
                    data: {
                        user_id: params.user_id,
                        contract_id: params.contract_id,
                        role_id: params.role_id
                    }
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getUserDutiesForSafety({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/eme-safety-app/project-user-duty`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
}

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}